import { Component, ViewEncapsulation, OnInit, ViewChild } from '@angular/core';
import { Globals } from '../globals';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { SortDescriptor, process } from '@progress/kendo-data-query';
declare var $, PerfectScrollbar, Swal: any, Bloodhound: any;
declare function myInput(): any;

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  notificationList;
  currentDate = new Date();
  yesterdayDate = new Date();
  beforeWeekDate = new Date();
  UserId: any;
  RoleId: any;
  isAdmin: any;
  exportName;
  p;
  auto;
  constructor(public globals: Globals, private router: Router, private route: ActivatedRoute,
    private NotificationService: NotificationService) { }

  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
  public gridData;

  public sort: SortDescriptor[] = [{
    field: 'notification_text',
    dir: 'asc'
  }];

  ngOnInit() {

    setTimeout(function () {

      // $(document).ready(function () {
      //   const body = document.querySelector('body');
      //   body.style.setProperty('--screen-height', $(window).height() + "px");
      // });
      new PerfectScrollbar('.content_height');

    }, 100);

    let todaysdate = this.globals.todaysdate;
    this.exportName = 'Assessment–AllNotifications–' + todaysdate;
    this.yesterdayDate.setDate(this.currentDate.getDate() - 1);
    this.beforeWeekDate.setDate(this.currentDate.getDate() - 7);

    this.globals.isLoading = true;
    this.isAdmin = false;
    // if (this.globals.authData.RoleId == 1 || this.globals.authData.RoleId == 2) {
    //   this.isAdmin = true;
    // }
    // var notificationData= { 'UserId': this.globals.authData.UserId, 'RoleId': this.globals.authData.RoleId, 'isAdmin':this.isAdmin };
    this.UserId = this.globals.authData.UserId;

    var entity = {
      'role_id' : this.globals.authData.roles_id,
      'user_id' : this.globals.authData.id,
    }
    this.NotificationService.getAllNotifications(entity)
      .then((data) => {
        console.log(data);
        this.gridData = data['data'];
        this.notificationList = data['data'];
        this.globals.isLoading = false;
      },
        (error) => {
          this.globals.isLoading = false;
              // this.globals.pageNotfound(error.error.code);
        });

  }

  dismissNotification(notifications) {

    var dismis = { 'id': notifications.id, 'type': 3 };
    this.globals.isLoading = true;
    this.NotificationService.clearDismissNotification(dismis)
      .then((data) => {
        // let index = this.notificationList.indexOf(notifications);
        // if (index != -1) {
        //   this.notificationList.splice(index, 1);
        // }
        var notificationList = [...this.notificationList];
              let index = notificationList.indexOf(notifications);
              if (index != -1) {
                notificationList.splice(index, 1);
              }
              this.notificationList = [...notificationList];
              this.gridData = this.notificationList;
        this.globals.isLoading = false;
        //$('#dataTables-example').dataTable().fnDeleteRow(index);
        Swal.fire({
          type: this.globals.configurationText.sweetAlertTypeIconSuccess,
          icon: this.globals.configurationText.sweetAlertTypeIconSuccess,
          customClass: this.globals.configurationText.sweetAlertClassSuccess,
          toast: true,
          title: 'Notification has been dismissed successfully',
          animation: true,
          position: this.globals.configurationText.sweetAlertPosition,
          showConfirmButton: false,
          timer: this.globals.configurationText.sweetAlertTimer,
          timerProgressBar: true,
          showCancelButton: true,
          cancelButtonText: 'x',
        });
      },
        (error) => {
          this.globals.isLoading = false;
              // this.globals.pageNotfound(error.error.code);
        });
  }
  public onFilter(inputValue: string): void {
    this.notificationList = process(this.gridData, {
      filter: {
        logic: "or",
        filters: [
          {
            field: 'notification_text',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'created_at',
            operator: 'contains',
            value: inputValue
          }
        ],
      }
    }).data;

    this.dataBinding.skip = 0;
  }

  redirect(action_url)
  {
    window.location.href = action_url;
  }
}
